import React from 'react';
import { Users, Video, Trophy, TrendingUp } from 'lucide-react';
import './Services.css';

const servicesData = [
  {
    id: 1,
    icon: Users,
    title: 'Talent',
    description: 'Exclusive family office operations for elite athletes. Currently managing and overseeing all business interests for Hardik Pandya.'
  },
  {
    id: 2,
    icon: Video,
    title: 'Content',
    description: 'Creating, producing, and distributing compelling sports narratives that foster authentic fan connections globally.'
  },
  {
    id: 3,
    icon: Trophy,
    title: 'IP',
    description: 'Conceptualizing and bringing to life new sports events and formats with robust go-to-market strategies.'
  },
  {
    id: 4,
    icon: TrendingUp,
    title: 'Consulting',
    description: 'Deep market intelligence and data-backed insights solving complex challenges for sports organizations and brands, including sponsorship activations that ensures measurable impact and engagement for all partnerships.'
  }
];

const Services = () => {
  return (
    <section id="services" className="services-section">
      <div className="container">
        <div className="section-header animate-fadeInUp">
          <h2 className="section-title">Our Verticals</h2>
        </div>

        <div className="services-grid">
          {servicesData.map((service, index) => {
            const Icon = service.icon;
            return (
              <div 
                key={service.id} 
                className={`service-card animate-scaleIn delay-${(index + 1) * 100}`}
              >
                <div className="icon-wrapper">
                  <Icon size={32} className="service-icon" />
                </div>
                <h3 className="service-title">{service.title}</h3>
                <p className="service-description">{service.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
